import { createAction, props } from '@ngrx/store';
import { System, VirtualRTStateType } from 'ngx-core-services';

import { SystemDefinition } from '..';

export const requestToAddASystem = createAction(
  '[System] Request to Add a System',
  props<{
    systemId: string;
    system: System,
    withAutomaticSelection: boolean,
    withAutomaticSubscription: boolean,
    comment: string,
    observerKey: string,
  }>()
);

export const removeSystem = createAction(
  '[System] Remove System',
  props<{ systemId: string }>()
);

export const addSystem = createAction(
  '[System] Add System',
  props<{
    systemId: string;
    system: System;
    withAutomaticSubscription: boolean;
  }>()
);

export const systemSelection = createAction(
  '[System] System Selection',
  props<{ systemId: string }>()
);

export const updateSystem = createAction(
  '[System] Update System',
  props<{ systemId: string; changes: Partial<SystemDefinition> }>()
);

export const updateCurrentObservers = createAction(
  '[System] Update Observer Count',
  props<{ systemId: string; observerKey: string; operation: 'add' | 'remove' }>()
);

export const setSystemSubscribed = createAction(
  '[System] Set System Subscribed',
  props<{ systemId: string }>()
);

export const setSystemUnsubscribed = createAction(
  '[System] Set System Unsubscribed',
  props<{ systemId: string }>()
);

export const checkSystemMetadata = createAction(
  '[System] Check System metadata',
  props<{ systemId: string }>()
);

export const checkSystemMetadataSuccess = createAction(
  '[System] Check System metadata Success',
  props<{ systemId: string; comment: string }>()
);

export const checkSystemMetadataFailed = createAction(
  '[System] Check System metadata Failed',
  props<{ systemId: string; error: string }>()
);

export const changeTemporarySystemState = createAction(
  '[System] Change Temporary System State',
  props<{
    systemId: string,
    state: 'inProgress' | 'success' | 'error',
    withAutomaticSelection: boolean,
  }>()
);

export const changeMetadataLoadingState = createAction(
  '[System] Change Metadata Loading State',
  props<{ systemId: string, loading: boolean }>()
);

export const updateVirtualRTStatus = createAction(
  '[System] Update Virtual RT Status',
  props<{ systemId: string, virtualRTStatus: VirtualRTStateType }>()
);
